import { render, staticRenderFns } from "./activity-turntable.vue?vue&type=template&id=b15b658c&scoped=true&"
import script from "./activity-turntable.vue?vue&type=script&lang=js&"
export * from "./activity-turntable.vue?vue&type=script&lang=js&"
import style0 from "./activity-turntable.vue?vue&type=style&index=0&id=b15b658c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15b658c",
  null
  
)

export default component.exports